function initialState () {
	return {space: {}};
}

export default {
	state: initialState,
	getters: {
		space: state => state.space
	},

	mutations: {
		space(state, spaceObj) {
			state.space = JSON.parse(JSON.stringify(spaceObj));
		},

		addSpaceNode(state, nodeObj) {
			state.space.nodes.push(nodeObj);
		},

		deleteSpaceNode(state, nodeId) {
			state.space.nodes = state.space.nodes.filter((node) => {
				return node.id !== nodeId;
			});
			state.space.links = state.space.links.filter((link) => {
				return link.from !== nodeId && link.to !== nodeId
			});
		},

		updateSpaceNodePosition(state, payload) {
			state.space.nodes[payload.nodeIndex].x = payload.left;
			state.space.nodes[payload.nodeIndex].y = payload.top;
		},

		addSpaceLink(state, linkObj) {
			state.space.links.push(linkObj);
		},

		deleteSpaceLink(state, linkId) {
			state.space.links = state.space.links.filter((item) => {
				return item.id !== linkId;
			});
		},

		resetSpace (state) {
			Object.assign(state, initialState());
		}
	},

	actions: {
		editSpace({commit}, payload) {
			return new Promise((resolve, reject) => {
				commit('space', payload.spaceObj);
				resolve();
			});
		},

		saveSpace({commit}, payload) {
			return new Promise((resolve, reject) => {
				commit('saveSpace', payload.spaceObj);
				resolve();
			});
		},

		addSpaceNode({commit}, payload) {
			return new Promise((resolve, reject) => {
				commit('addSpaceNode', payload.newNode);
				resolve();
			});
		},

		deleteSpaceNode({commit}, payload) {
			return new Promise((resolve, reject) => {
				commit('deleteSpaceNode', payload.nodeId);
				resolve();
			});
		},

		updateSpaceNodePosition({commit}, payload) {
			return new Promise((resolve, reject) => {
				commit('updateSpaceNodePosition', payload);
				resolve();
			});
		},

		addSpaceLink({commit}, payload) {
			return new Promise((resolve, reject) => {
				commit('addSpaceLink', payload.newLink);
				resolve();
			});
		},

		deleteSpaceLink({commit}, payload) {
			return new Promise((resolve, reject) => {
				commit('deleteSpaceLink', payload.linkId);
				resolve();
			});
		},

		resetSpace ({commit}) {
			return new Promise((resolve, reject) => {
				commit('resetSpace');
				resolve();
			});
		}
	}
}